module.exports = __webpack_public_path__ + "img/badge_color_ms-finaid.e7cb67c2.svg";